module.exports = __webpack_public_path__ + "static/media/ic_employees.50e256eb.png";